import React, { useMemo, useState, useEffect } from 'react'
import { Button, FormGroup, Input, Label, Spinner } from 'reactstrap'
import { IconButton } from '@mui/material'
import { Visibility, Edit, MonetizationOn, OpenInNew, AttachFile, Description, People, Link as LinkIcon } from '@material-ui/icons'
import MaterialReactTable from 'material-react-table'
import { MRT_Localization_PT } from 'material-react-table/locales/pt'
import moment from 'moment'
import qs from 'qs'
import oikosApi from '../../../services/oikos'
import { currencyFormatter } from '../../../utils/currencyFormatter'
import { notifyError, notifySuccess } from '../../../utils/notify'
import { selectValues } from '../../../utils/fc'
import Select from '../Input/Select'
import MaskedInput from '../Input/MaskedInput'
import CompactAddFiles from '../Files/CompactAddFiles'
import ModalFormDisparoEmails from '../../Modals/ModalFormDisparoEmails/ModalFormDisparoEmails'
import ModalFormContrForn from '../../Modals/ModalFormContrForn/ModalFormContrForn'
import ModalContrFornInfo from '../../Modals/ModalContrFornInfo/ModalContrFornInfo'
import ModalConfirmacao from '../../Modals/ModalConfirmacao/ModalConfirmacao'
import { EQUIPE_CATEG_GR_ID, fetchOrcItemsForCentroDeCusto } from '../../Modals/ModalPedidoCompra/ModalPedidoCompra'
import { savePedidoCompraOuVagaDocuments } from '../../Modals/ModalPedidoCompra/usePedidoCompraEquipeActions'
import {
  COMPRA_STATUS_INFO_ENVIADA,
  compraCotacaoContrFornHideProps,
  compraCotacaoContrFornHidePropsComContratado,
  getCompraCotacaoFields,
  mrtHeadCellProps,
  mrtTopToolbarProps,
  pedidoCompraTemCotacaoContratada,
  pedidoCompraTemContratacaoEmAndamento,
  pedidoCompraTemOrcItemVinculado,
  PEDIDO_COMPRA_TP_RAPIDA,
  PEDIDO_COMPRA_TP_ADESAO,
  isPedidoCompraComContrato,
} from './compraCotacaoTableUtils'

const getRowListagemKey = (row, showEquipePedidoCompraFields = false) => {
  if (showEquipePedidoCompraFields) {
    return String(row?.vaga_id ?? row?.pedidoCompra_id ?? '')
  }
  return String(row?.pedidoCompra_id ?? '')
}

const getRowExpandId = (row, showEquipePedidoCompraFields = false) => {
  if (showEquipePedidoCompraFields) {
    return Number(row?.vaga_id) || Number(row?.pedidoCompra_id) || 0
  }
  return Number(row?.pedidoCompra_id) || 0
}

const getCandidatoFields = () => ({
  candidato_nome: 'candidato_nome',
  "(SELECT orcItem_id FROM vaga WHERE vaga.vaga_id = candidato.vaga_id LIMIT 1)": "orcItem_id",
  "(SELECT pf_emailProf FROM pf WHERE pf.pf_id = (SELECT pf_id FROM orcItem WHERE orcItem.orcItem_id = (SELECT orcItem_id FROM vaga WHERE vaga.vaga_id = candidato.vaga_id LIMIT 1) LIMIT 1) LIMIT 1)": "pf_emailProf",
  "(SELECT compraStatus_nome FROM compraStatus WHERE compraStatus.compraStatus_id = (SELECT compraStatus_id FROM compraCotacao WHERE compraCotacao.compraCotacao_id = candidato.compraCotacao_id LIMIT 1) LIMIT 1)": "compraStatus_nome",
  "(SELECT compraStatus_id FROM compraCotacao WHERE compraCotacao.compraCotacao_id = candidato.compraCotacao_id LIMIT 1)": "compraStatus_id",
  "(SELECT compraCotacao_nomeInteressado FROM compraCotacao WHERE compraCotacao.compraCotacao_id = candidato.compraCotacao_id LIMIT 1)": "compraCotacao_nomeInteressado",
  "(SELECT a.arquivo_caminho FROM arquivo a INNER JOIN documento d ON a.arquivo_tabId = d.documento_id AND a.arquivo_tabRef = 'documento' INNER JOIN documentoVinc dv ON dv.documento_id = d.documento_id WHERE dv.documentoVinc_tabRef = 'candidato' AND dv.documentoVinc_tabId = candidato.candidato_id AND d.tpDocumento_id = 37 AND COALESCE(d.documento_ativo, 1) = 1 AND COALESCE(a.arquivo_ativo, 1) = 1 AND COALESCE(dv.documentoVinc_ativo, 1) = 1 ORDER BY a.arquivo_id DESC LIMIT 1)": "candidato_anexo_caminho",
  compraCotacao_id: "compraCotacao_id",
  "(SELECT contrForn_id FROM contrForn WHERE contrForn.compraCotacao_id = candidato.compraCotacao_id LIMIT 1)": "contrForn_id",
  "(SELECT orcItem_id FROM contrForn WHERE contrForn.compraCotacao_id = candidato.compraCotacao_id LIMIT 1)": "contrForn_orcItem_id",
})

const DRAFT_ROW_ID = '__draft__'

const expandedDetailPanelStyle = {
  backgroundColor: '#f4fafc',
  border: '1px solid #b7d4df',
  borderRadius: 4,
}

const createEmptyDraft = () => ({
  isDraft: true,
  compraCotacao_id: DRAFT_ROW_ID,
  compraCotacao_desc: '',
  compraCotacao_vlr: '',
  compraCotacao_nomeInteressado: '',
  compraCotacao_link: '',
  files: [],
})

const OIKOS_FILES_BASE = 'https://oikos.ecoss.is/oikos/'

const BADGE_ICON_STYLE = { fontSize: 14, verticalAlign: 'text-bottom', marginLeft: 2 }

const BADGE_TONE_COLORS = {
  info: '#17a2b8',
  primary: '#007bff',
  secondary: '#6c757d',
}

const BadgeCountWithIcon = ({ count, icon: Icon, label, tone = 'secondary' }) => {
  const color = BADGE_TONE_COLORS[tone] || BADGE_TONE_COLORS.secondary
  return (
    <span className="d-inline-flex align-items-center" style={{ gap: 2, color }}>
      <span>{count}</span>
      <Icon style={{ ...BADGE_ICON_STYLE, color }} titleAccess={label} />
    </span>
  )
}

const normalizeExternalUrl = (rawUrl) => {
  const url = String(rawUrl || '').trim()
  if (!url) return null
  if (/^https?:\/\//i.test(url)) return url
  return `https://${url}`
}

const buildOikosFileUrl = (arquivoCaminho) => {
  const path = String(arquivoCaminho || '').trim()
  if (!path) return null
  if (/^https?:\/\//i.test(path)) return path
  return `${OIKOS_FILES_BASE}${path.replace(/^\//, '')}`
}

const PedidosCompraListTable = ({
  pedidosCompra = [],
  showEquipePedidoCompraFields = false,
  showOrcItemDesc = false,
  showVlrLimite = true,
  onViewPedidoCompra,
  onEditPedidoCompra,
  onAbrirCotacaoPedidoCompra,
  onViewCompraCotacao,
  fetchPedidoCompraDocuments,
  isLoading = false,
  loadingLabel = 'Carregando cotações...',
  compraCotacoesRefreshKey = 0,
  onPedidoCompraOrcItemLinked = async () => {},
  onPedidoCompraContratado = async () => {},
  onOpenContrForn = null,
}) => {
  const [expandedPedidosCompra, setExpandedPedidosCompra] = useState({})
  const [compraCotacoesByPedidoCompraId, setCompraCotacoesByPedidoCompraId] = useState({})
  const [isLoadingCompraCotacoesByPedidoCompraId, setIsLoadingCompraCotacoesByPedidoCompraId] = useState({})
  const [selCentroDeCustoLink, setSelCentroDeCustoLink] = useState([])
  const [selOrcItemsLink, setSelOrcItemsLink] = useState([])
  const [isLoadingOrcItemsLink, setIsLoadingOrcItemsLink] = useState(false)
  const [isSavingOrcItemLink, setIsSavingOrcItemLink] = useState(false)
  const [linkOrcItemModal, setLinkOrcItemModal] = useState({
    open: false,
    compraCotacao: null,
    pedidoCompra: null,
  })
  const [linkOrcItemForm, setLinkOrcItemForm] = useState({
    centroDeCustoRubr_id: null,
    orcItem_id: null,
  })
  const [contrFornModalAfterLink, setContrFornModalAfterLink] = useState({
    open: false,
    compraCotacao: null,
    pedidoCompra: null,
    treatAsPadrao: false,
  })
  const [draftByPedidoCompraId, setDraftByPedidoCompraId] = useState({})
  const [isSavingDraftByPedidoCompraId, setIsSavingDraftByPedidoCompraId] = useState({})

  const updateDraftField = (pedidoCompraId, field, value) => {
    const key = String(pedidoCompraId)
    setDraftByPedidoCompraId((prev) => ({
      ...prev,
      [key]: {
        ...(prev[key] || createEmptyDraft()),
        [field]: value,
      },
    }))
  }

  const clearDraft = (pedidoCompraId) => {
    const key = String(pedidoCompraId)
    setDraftByPedidoCompraId((prev) => {
      const next = { ...prev }
      delete next[key]
      return next
    })
  }

  const handleSaveDraftProposta = async (pedidoCompra) => {
    const pedidoCompraId = Number(pedidoCompra?.pedidoCompra_id) || 0
    if (!pedidoCompraId) {
      notifyError('Não foi possível identificar a cotação.')
      return
    }

    const draftKey = String(pedidoCompraId)
    const draft = draftByPedidoCompraId[draftKey] || createEmptyDraft()
    const descricao = String(draft.compraCotacao_desc || '').trim()
    const fornecedor = String(draft.compraCotacao_nomeInteressado || '').trim()
    const pedidoCompraTpId = Number(pedidoCompra?.pedidoCompraTp_id) || 0
    const showLinkField = pedidoCompraTpId === PEDIDO_COMPRA_TP_RAPIDA
      || pedidoCompraTpId === PEDIDO_COMPRA_TP_ADESAO
    const showAnexosField = pedidoCompraTpId !== PEDIDO_COMPRA_TP_RAPIDA
    const link = showLinkField ? String(draft.compraCotacao_link || '').trim() : ''
    const valor = Number(draft.compraCotacao_vlr)

    if (!descricao) {
      notifyError('Preencha a descrição da proposta.')
      return
    }
    if (!fornecedor) {
      notifyError('Preencha o fornecedor da proposta.')
      return
    }
    if (!Number.isFinite(valor) || valor <= 0) {
      notifyError('Preencha o valor da proposta.')
      return
    }

    try {
      setIsSavingDraftByPedidoCompraId((prev) => ({ ...prev, [draftKey]: true }))
      const insertResponse = await oikosApi.post('/', {
        action: 'insert',
        table: 'compraCotacao',
        data: {
          pedidoCompra_id: pedidoCompraId,
          compraCotacao_vlr: valor,
          compraCotacao_nomeInteressado: fornecedor,
          compraCotacao_link: link || undefined,
          compraCotacao_desc: descricao,
          compraStatus_id: 1,
          compraCotacao_dtCotacao: moment().format('YYYY-MM-DD'),
        },
      })
      const newCompraCotacaoId = Number(insertResponse?.data?.[0]?.compraCotacao_id) || 0
      const draftFiles = showAnexosField && Array.isArray(draft.files) ? draft.files : []

      if (newCompraCotacaoId && draftFiles.length > 0) {
        await savePedidoCompraOuVagaDocuments(draftFiles, newCompraCotacaoId, 'compraCotacao')
      }

      clearDraft(pedidoCompraId)
      await fetchCompraCotacoesForRow(pedidoCompra)
      notifySuccess('Cotação cadastrada com sucesso.')
    } catch (e) {
      console.log('Erro ao salvar proposta inline:', e)
      notifyError('Erro ao salvar a proposta.')
    } finally {
      setIsSavingDraftByPedidoCompraId((prev) => ({ ...prev, [draftKey]: false }))
    }
  }

  const fetchCompraCotacoesForRow = async (listagemRow) => {
    const expandId = getRowExpandId(listagemRow, showEquipePedidoCompraFields)
    if (!expandId) return []

    const cacheKey = String(expandId)

    try {
      setIsLoadingCompraCotacoesByPedidoCompraId(prev => ({
        ...prev,
        [cacheKey]: true,
      }))

      let res = {}

      if (showEquipePedidoCompraFields) {
        const query = qs.stringify({
          action: 'get',
          table: 'candidato',
          data: {
            vaga_id: expandId,
          },
          fields: getCandidatoFields(),
        })
        res = await oikosApi.get(`/?${query}`)
        res.data = res?.data?.filter((row) => Number(row.compraCotacao_id) > 0) || []
      } else {
        const query = qs.stringify({
          action: 'get',
          table: 'compraCotacao',
          data: {
            pedidoCompra_id: expandId,
          },
          fields: getCompraCotacaoFields(),
        })
        res = await oikosApi.get(`/?${query}`)
      }

      const rows = Array.isArray(res.data) ? res.data : []
      setCompraCotacoesByPedidoCompraId(prev => ({
        ...prev,
        [cacheKey]: rows,
      }))
      return rows
    } catch (e) {
      setCompraCotacoesByPedidoCompraId(prev => ({
        ...prev,
        [cacheKey]: [],
      }))
      notifyError(!showEquipePedidoCompraFields ? 'Erro ao carregar cotacoes da cotação.' : 'Erro ao carregar candidatos da vaga.')
      console.log(!showEquipePedidoCompraFields ? 'Erro ao carregar compraCotacao por pedidoCompra:' : 'Erro ao carregar candidato por vaga:', e)
      return []
    } finally {
      setIsLoadingCompraCotacoesByPedidoCompraId(prev => ({
        ...prev,
        [cacheKey]: false,
      }))
    }
  }

  const handleExpandedChange = (updater) => {
    setExpandedPedidosCompra((prev) => {
      const next = typeof updater === 'function' ? updater(prev) : updater

      Object.entries(next || {}).forEach(([rowId, isOpen]) => {
        if (!isOpen) return

        const listagemRow = pedidosCompra.find((item) => (
          getRowListagemKey(item, showEquipePedidoCompraFields) === rowId
        ))
        if (!listagemRow) return

        const expandId = getRowExpandId(listagemRow, showEquipePedidoCompraFields)
        const cacheKey = String(expandId)

        if (
          expandId
          && !compraCotacoesByPedidoCompraId[cacheKey]
          && !isLoadingCompraCotacoesByPedidoCompraId[cacheKey]
        ) {
          fetchCompraCotacoesForRow(listagemRow)
        }
      })

      return next
    })
  }

  useEffect(() => {
    if (!compraCotacoesRefreshKey) return

    Object.entries(expandedPedidosCompra || {}).forEach(([rowId, isOpen]) => {
      if (!isOpen) return

      const listagemRow = pedidosCompra.find((item) => (
        getRowListagemKey(item, showEquipePedidoCompraFields) === rowId
      ))
      if (listagemRow) {
        fetchCompraCotacoesForRow(listagemRow)
      }
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [compraCotacoesRefreshKey])

  const fetchCentroDeCustoForLinkModal = async () => {
    try {
      const options = await selectValues('orcRubr', 'orcRubr_id', 'orcRubr_nome', {
        orcRubr_ativo: 1,
        orcRubr_mae: '!IN!(1, 2)',
      })
      setSelCentroDeCustoLink(
        (options || []).sort((a, b) => {
          if (a.label < b.label) return -1
          if (a.label > b.label) return 1
          return 0
        }),
      )
    } catch (error) {
      console.error('Erro ao carregar centros de custo:', error)
      setSelCentroDeCustoLink([])
    }
  }

  const handleOpenLinkOrcItemModal = async (compraCotacao, pedidoCompra) => {
    setLinkOrcItemForm({ centroDeCustoRubr_id: null, orcItem_id: null })
    setSelOrcItemsLink([])
    setLinkOrcItemModal({ open: true, compraCotacao, pedidoCompra })
    if (selCentroDeCustoLink.length === 0) {
      await fetchCentroDeCustoForLinkModal()
    }
  }

  const handleCloseLinkOrcItemModal = () => {
    if (isSavingOrcItemLink) return
    setLinkOrcItemModal({ open: false, compraCotacao: null, pedidoCompra: null })
    setLinkOrcItemForm({ centroDeCustoRubr_id: null, orcItem_id: null })
    setSelOrcItemsLink([])
  }

  const handleCentroDeCustoLinkChange = async (option) => {
    const centroId = option?.value ?? null
    setLinkOrcItemForm({ centroDeCustoRubr_id: centroId, orcItem_id: null })
    setSelOrcItemsLink([])
    if (!centroId) return

    try {
      setIsLoadingOrcItemsLink(true)
      const options = await fetchOrcItemsForCentroDeCusto(centroId)
      setSelOrcItemsLink(Array.isArray(options) ? options : [])
    } catch (error) {
      console.error('Erro ao carregar itens orcamentarios:', error)
      notifyError('Erro ao carregar itens orçamentários.')
      setSelOrcItemsLink([])
    } finally {
      setIsLoadingOrcItemsLink(false)
    }
  }

  const handleSavePedidoCompraOrcItem = async () => {
    const pedidoCompraId = Number(linkOrcItemModal.pedidoCompra?.pedidoCompra_id) || 0
    const orcItemId = Number(linkOrcItemForm.orcItem_id) || 0
    const selectedOrcItem = selOrcItemsLink.find((item) => Number(item.value) === orcItemId)

    if (!pedidoCompraId) {
      notifyError('Não foi possível identificar a cotação.')
      return
    }
    if (!linkOrcItemForm.centroDeCustoRubr_id) {
      notifyError('Selecione um centro de custo.')
      return
    }
    if (!orcItemId) {
      notifyError('Selecione um item orçamentário.')
      return
    }
    const orcItemPfId = Number(selectedOrcItem?.pf_id) || 0
    if (!orcItemPfId) {
      notifyError('Item orçamentário sem responsável')
      return
    }

    try {
      setIsSavingOrcItemLink(true)
      await oikosApi.post('/', {
        action: 'update',
        table: 'pedidoCompra',
        data: {
          pedidoCompra_id: pedidoCompraId,
          orcItem_id: orcItemId,
          pf_id: orcItemPfId,
        },
      })

      const updatedPedidoCompra = {
        ...linkOrcItemModal.pedidoCompra,
        orcItem_id: orcItemId,
        pf_id: orcItemPfId,
        orcItem_desc: selectedOrcItem?.label || linkOrcItemModal.pedidoCompra?.orcItem_desc,
        centroDeCustoRubr_id: linkOrcItemForm.centroDeCustoRubr_id,
        pf_emailProf: selectedOrcItem?.pf_emailProf || linkOrcItemModal.pedidoCompra?.pf_emailProf,
      }
      const updatedCompraCotacao = {
        ...linkOrcItemModal.compraCotacao,
        orcItem_id: orcItemId,
      }

      await onPedidoCompraOrcItemLinked(updatedPedidoCompra)
      await fetchCompraCotacoesForRow(updatedPedidoCompra)

      setLinkOrcItemModal({ open: false, compraCotacao: null, pedidoCompra: null })
      setLinkOrcItemForm({ centroDeCustoRubr_id: null, orcItem_id: null })
      setSelOrcItemsLink([])
      notifySuccess('Item orçamentário vinculado à cotação.')
      setContrFornModalAfterLink({
        open: true,
        compraCotacao: updatedCompraCotacao,
        pedidoCompra: updatedPedidoCompra,
        treatAsPadrao: isPedidoCompraComContrato(updatedPedidoCompra),
      })
    } catch (error) {
      console.error('Erro ao vincular item orcamentario ao pedidoCompra:', error)
      notifyError('Erro ao vincular item orçamentário à cotação.')
    } finally {
      setIsSavingOrcItemLink(false)
    }
  }

  const handleContrFornSuccess = async (pedidoCompra) => {
    if (pedidoCompra) {
      await fetchCompraCotacoesForRow(pedidoCompra)
    }
    await onPedidoCompraContratado?.(pedidoCompra)
  }

  const renderCompraCotacaoActions = (compraCotacao, pedidoCompra, compraCotacoes) => {
    const compraStatusId = Number(compraCotacao.compraStatus_id)
    const temCotacaoContratadaNoPedido = pedidoCompraTemCotacaoContratada(compraCotacoes)
    const orcItemVinculado = pedidoCompraTemOrcItemVinculado(pedidoCompra, compraCotacao)
    const pedidoSemOrcItem = !Number(pedidoCompra?.orcItem_id)
    const orcItemIdResolvido = Number(
      compraCotacao.contrForn_orcItem_id
      || compraCotacao.orcItem_id
      || pedidoCompra?.orcItem_id,
    ) || null
    // No Equipe, o item orçamentário costuma ficar inativo assim que a vaga é aberta,
    // então a hierarquia (centro de custo/orçamento) já vem resolvida desde OrcItemsProj
    // (normalizeListagemRow) na linha de vaga, e não pode ser buscada de novo via
    // viewRubr_OrcItem (que só lista itens ativos).
    const centroDeCustoRubrIdResolvido = pedidoCompra?.centroDeCustoRubr_id || null
    const orcRubrIdResolvido = pedidoCompra?.orcRubr_id || null
    const orcItemLabelResolvido = pedidoCompra?.orcItem_label || null
    const compraCotacaoData = {
      ...compraCotacao,
      compraCotacao_id: compraCotacao.compraCotacao_id,
      compraCotacao_nomeInteressado: compraCotacao.compraCotacao_nomeInteressado
        || compraCotacao.candidato_nome,
      compraCotacao_vlr: compraCotacao.compraCotacao_vlr ?? compraCotacao.candidato_valorSalario,
      orcItem_id: orcItemIdResolvido,
      centroDeCustoRubr_id: centroDeCustoRubrIdResolvido,
      orcRubr_id: orcRubrIdResolvido,
      orcItem_label: orcItemLabelResolvido,
    }
    const pedidoCompraDataForContrForn = {
      ...pedidoCompra,
      // No Equipe, pedidoCompra aqui é a linha de vaga (tem vaga_id + orcItem_id)
      orcItem_id: orcItemIdResolvido || pedidoCompra?.orcItem_id || null,
      pf_emailProf: pedidoCompra?.pf_emailProf || compraCotacao.pf_emailProf,
      centroDeCustoRubr_id: centroDeCustoRubrIdResolvido,
      orcRubr_id: orcRubrIdResolvido,
      orcItem_label: orcItemLabelResolvido,
      vaga_id: pedidoCompra?.vaga_id || null,
      vaga_documentosObrigatorios: pedidoCompra?.vaga_documentosObrigatorios
        || pedidoCompra?.vagaDocumentosObrigatorios
        || null,
      vaga_beneficios: pedidoCompra?.vaga_beneficios
        || pedidoCompra?.vagaBeneficios
        || null,
    }
    const contrFornData = {
      ...compraCotacaoData,
      orcItem_id: orcItemIdResolvido,
      pf_emailProf: compraCotacao.pf_emailProf || pedidoCompra?.pf_emailProf,
    }

    const renderOpenContrFornLink = () => {
      const contrFornId = Number(compraCotacao.contrForn_id)
      if (!contrFornId || typeof onOpenContrForn !== 'function') return null
      return (
        <IconButton
          size="small"
          title="Abrir contrato em Fornecedores"
          onClick={() => onOpenContrForn(contrFornId, {
            compraCotacaoId: Number(compraCotacao.compraCotacao_id) || null,
          })}
        >
          <LinkIcon fontSize="small" />
        </IconButton>
      )
    }

    const comContrato = isPedidoCompraComContrato(pedidoCompra)
    const existingContrFornId = Number(compraCotacao.contrForn_id) || 0

    const renderContrFornHireModal = ({ supplierInfoValidationMode = false } = {}) => (
      <ModalFormContrForn
        supplierInfoValidationMode={supplierInfoValidationMode}
        compraCotacaoData={compraCotacaoData}
        pedidoCompraData={pedidoCompraDataForContrForn}
        contrFornData={existingContrFornId ? { contrForn_id: existingContrFornId } : undefined}
        loadExistingContrFornOnOpen={Boolean(existingContrFornId)}
        showEquipePedidoCompraFields={showEquipePedidoCompraFields}
        centroDeCustoDisabled={orcItemVinculado}
        orcItemDisabled={orcItemVinculado}
        {...(comContrato
          ? compraCotacaoContrFornHidePropsComContratado
          : compraCotacaoContrFornHideProps)}
        onSuccess={async () => {
          await handleContrFornSuccess(pedidoCompra)
        }}
      />
    )

    if (existingContrFornId) {
      return renderOpenContrFornLink()
    }

    if (compraStatusId === 3) {
      return (
        <ModalContrFornInfo
          contrFornData={contrFornData}
          setListaParcelasDetails={() => {}}
          updateOneEvento={async () => []}
        />
      )
    }

    if (compraStatusId === COMPRA_STATUS_INFO_ENVIADA && !temCotacaoContratadaNoPedido) {
      if (pedidoSemOrcItem) {
        return (
          <IconButton
            size="small"
            title="Validar informações do fornecedor"
            onClick={() => handleOpenLinkOrcItemModal(compraCotacaoData, pedidoCompra)}
          >
            <MonetizationOn />
          </IconButton>
        )
      }

      return renderContrFornHireModal({
        supplierInfoValidationMode: comContrato,
      })
    }

    if (compraStatusId === 1 && !temCotacaoContratadaNoPedido) {
      const temOutraContratacaoEmAndamento = pedidoCompraTemContratacaoEmAndamento(compraCotacoes, {
        excludeCompraCotacaoId: compraCotacaoData.compraCotacao_id,
      })
      if (temOutraContratacaoEmAndamento) return null

      if (pedidoSemOrcItem) {
        return (
          <IconButton
            size="small"
            title="Contratar"
            onClick={() => handleOpenLinkOrcItemModal(compraCotacaoData, pedidoCompra)}
          >
            <MonetizationOn />
          </IconButton>
        )
      }

      return renderContrFornHireModal()
    }

    return null
  }

  const columns = useMemo(() => {
    const baseColumns = [
      {
        accessorKey: 'pedidoCompra_desc',
        header: 'Descrição',
        Cell: ({ row }) => row.original.pedidoCompra_desc || '-',
      },
    ]

    if (showOrcItemDesc) {
      baseColumns.push({
        accessorKey: 'orcItem_desc',
        header: 'Item orçamentário',
        Cell: ({ row }) => row.original.orcItem_desc || '-',
      })
    }

    if (showVlrLimite) {
      baseColumns.push({
        accessorKey: 'pedidoCompra_vlrLimite',
        header: 'Valor limite',
        Cell: ({ row }) => currencyFormatter.format(Number(row.original.pedidoCompra_vlrLimite || 0)),
        /* muiTableBodyCellProps: { align: 'right' },
        muiTableHeadCellProps: { align: 'right' }, */
      })
    }

    return [
      ...baseColumns,
      {
        accessorKey: 'pedidoCompra_dtSolicitacao',
        header: 'Data de solicitação',
        Cell: ({ row }) => (
          row.original.pedidoCompra_dtSolicitacao
            ? moment(row.original.pedidoCompra_dtSolicitacao).format('DD/MM/YYYY')
            : '-'
        ),
      },
      {
        accessorKey: 'pf_nomeExibicao',
        header: 'Responsável',
        Cell: ({ row }) => row.original.pf_nomeExibicao || '-',
      },
      ...(showEquipePedidoCompraFields ? [{
        id: 'inhireLink',
        header: 'Link',
        enableColumnActions: false,
        enableSorting: false,
        Cell: ({ row }) => {
          const inhireId = String(row.original.vaga_inhireId || '').trim()
          if (!inhireId) return '-'

          const href = `https://ecossis.inhire.app/jobs/${encodeURIComponent(inhireId)}`
          return (
            <IconButton
              size="small"
              title="Abrir vaga no InHire"
              onClick={() => window.open(href, '_blank', 'noopener,noreferrer')}
            >
              <OpenInNew fontSize="small" />
            </IconButton>
          )
        },
      }] : []),
      {
        id: 'acoes',
        header: 'Ações',
        enableColumnActions: false,
        enableSorting: false,
        Cell: ({ row }) => {
          const pedidoCompra = row.original
          const expandId = getRowExpandId(pedidoCompra, showEquipePedidoCompraFields)
          const cacheKey = String(expandId)
          const loadedCotacoes = compraCotacoesByPedidoCompraId[cacheKey]
          const propostasCount = Array.isArray(loadedCotacoes)
            ? loadedCotacoes.length
            : (Number(pedidoCompra.compraCotacao_count) || 0)
          const propostaSingular = showEquipePedidoCompraFields ? 'candidatura' : 'proposta'
          const propostaPlural = showEquipePedidoCompraFields ? 'candidaturas' : 'propostas'
          const propostasLabel = propostasCount === 1 ? propostaSingular : propostaPlural
          const PropostasIcon = showEquipePedidoCompraFields ? People : Description

          return (
            <div className="d-flex align-items-center flex-wrap" style={{ gap: '6px' }}>
              {onViewPedidoCompra && (
                <IconButton
                  size="small"
                  title={!showEquipePedidoCompraFields ? 'Visualizar cotação' : 'Visualizar vaga'}
                  onClick={() => onViewPedidoCompra(pedidoCompra)}
                >
                  <Visibility fontSize="small" />
                </IconButton>
              )}
              {Number(pedidoCompra.pedidoCompraStatus_id) === 6 && onEditPedidoCompra && (
                <IconButton
                  size="small"
                  title={!showEquipePedidoCompraFields ? 'Editar cotação recusada' : 'Editar vaga recusada'}
                  onClick={() => onEditPedidoCompra(pedidoCompra)}
                >
                  <Edit fontSize="small" />
                </IconButton>
              )}
              {Number(pedidoCompra.pedidoCompraStatus_id) === 5 &&
                <ModalFormDisparoEmails pedidoCompraData={pedidoCompra} fetchPedidoCompraDocuments={fetchPedidoCompraDocuments} />
              }
              <span
                title={`${propostasCount} ${propostasLabel}`}
                style={{ background: 'transparent', padding: 0 }}
              >
                <BadgeCountWithIcon
                  count={propostasCount}
                  icon={PropostasIcon}
                  label={propostasLabel}
                  tone={propostasCount > 0 ? 'primary' : 'secondary'}
                />
              </span>
            </div>
          )
        },
      },
    ]
  }, [
    showOrcItemDesc,
    showVlrLimite,
    onViewPedidoCompra,
    onEditPedidoCompra,
    showEquipePedidoCompraFields,
    fetchPedidoCompraDocuments,
    compraCotacoesByPedidoCompraId,
  ])

  const compraCotacaoColumns = useMemo(() => [
    ...(showEquipePedidoCompraFields ? [{
      id: 'data',
      header: 'Data de envio',
      Cell: ({ row }) => {
        const dateValue = row.original.candidato_dtCria;
        return dateValue ? moment(dateValue).format('DD/MM/YYYY') : '-';
      },
    }] : []),
    {
      id: 'valor',
      header: 'Valor',
      Cell: ({ row }) => currencyFormatter.format(Number(
        !showEquipePedidoCompraFields
          ? row.original.compraCotacao_vlr || 0
          : row.original.candidato_valorSalario || 0,
      )),
    },
    {
      id: 'interessado',
      header: 'Fornecedor',
      Cell: ({ row }) => (
        row.original.compraCotacao_nomeInteressado
        || row.original.candidato_nome
        || '-'
      ),
    },
    {
      id: 'anexo',
      header: 'Anexo',
      enableColumnActions: false,
      enableSorting: false,
      Cell: ({ row }) => {
        const anexoHref = buildOikosFileUrl(row.original.candidato_anexo_caminho)
        if (!anexoHref) return '-'

        return (
          <IconButton
            size="small"
            title="Abrir anexo"
            onClick={() => window.open(anexoHref, '_blank', 'noopener,noreferrer')}
          >
            <AttachFile style={{ fontSize: 18 }} />
          </IconButton>
        )
      },
    },
    /* {
      accessorKey: 'compraStatus_nome',
      header: 'Status',
      Cell: ({ row }) => row.original.compraStatus_nome || '-',
    }, */
  ], [
    showEquipePedidoCompraFields,
  ])

  const resolvedLoadingLabel = showEquipePedidoCompraFields
    ? 'Carregando vagas...'
    : loadingLabel

  const buildPedidoPropostaDetailColumns = (pedidoCompra, compraCotacoes) => {
    const pedidoCompraId = Number(pedidoCompra?.pedidoCompra_id) || 0
    const draftKey = String(pedidoCompraId)
    const draft = draftByPedidoCompraId[draftKey] || createEmptyDraft()
    const isSavingDraft = Boolean(isSavingDraftByPedidoCompraId[draftKey])
    const pedidoCompraTpId = Number(pedidoCompra?.pedidoCompraTp_id) || 0
    const showLinkColumn = pedidoCompraTpId === PEDIDO_COMPRA_TP_RAPIDA
      || pedidoCompraTpId === PEDIDO_COMPRA_TP_ADESAO
    const showAnexosColumn = pedidoCompraTpId !== PEDIDO_COMPRA_TP_RAPIDA

    const columns = [
      {
        id: 'descricao',
        header: 'Descrição',
        Cell: ({ row }) => {
          if (row.original.isDraft) {
            return (
              <Input
                type="text"
                bsSize="sm"
                placeholder="Descrição da proposta"
                value={draft.compraCotacao_desc || ''}
                disabled={isSavingDraft}
                onChange={(e) => updateDraftField(
                  pedidoCompraId,
                  'compraCotacao_desc',
                  e.target.value,
                )}
              />
            )
          }
          return row.original.compraCotacao_desc || '-'
        },
      },
      {
        id: 'valor',
        header: 'Valor',
        Cell: ({ row }) => {
          if (row.original.isDraft) {
            return (
              <MaskedInput
                unmask
                mask="R$ num"
                blocks={{
                  num: {
                    mask: Number,
                    scale: 2,
                    signed: false,
                    thousandsSeparator: '.',
                    padFractionalZeros: false,
                    normalizeZeros: false,
                    radix: ',',
                    min: 0,
                    max: 1000000000,
                  },
                }}
                lazy={false}
                value={String(draft.compraCotacao_vlr ?? '')}
                onAccept={(value) => updateDraftField(pedidoCompraId, 'compraCotacao_vlr', value)}
                disabled={isSavingDraft}
              />
            )
          }
          return currencyFormatter.format(Number(row.original.compraCotacao_vlr || 0))
        },
      },
      {
        id: 'interessado',
        header: 'Fornecedor',
        Cell: ({ row }) => {
          if (row.original.isDraft) {
            return (
              <Input
                type="text"
                bsSize="sm"
                placeholder="Nome do fornecedor"
                value={draft.compraCotacao_nomeInteressado || ''}
                disabled={isSavingDraft}
                onChange={(e) => updateDraftField(
                  pedidoCompraId,
                  'compraCotacao_nomeInteressado',
                  e.target.value,
                )}
              />
            )
          }
          return row.original.compraCotacao_nomeInteressado || '-'
        },
      },
    ]

    if (showLinkColumn) {
      columns.push({
        id: 'link',
        header: 'Link',
        enableColumnActions: false,
        enableSorting: false,
        Cell: ({ row }) => {
          if (row.original.isDraft) {
            return (
              <Input
                type="text"
                bsSize="sm"
                placeholder="https://"
                value={draft.compraCotacao_link || ''}
                disabled={isSavingDraft}
                onChange={(e) => updateDraftField(
                  pedidoCompraId,
                  'compraCotacao_link',
                  e.target.value,
                )}
              />
            )
          }

          const href = normalizeExternalUrl(row.original.compraCotacao_link)
          if (!href) return '-'

          return (
            <IconButton
              size="small"
              title="Abrir link"
              onClick={() => window.open(href, '_blank', 'noopener,noreferrer')}
            >
              <OpenInNew fontSize="small" />
            </IconButton>
          )
        },
      })
    }

    if (showAnexosColumn) {
      columns.push({
        id: 'anexos',
        header: 'Anexos',
        enableColumnActions: false,
        enableSorting: false,
        Cell: ({ row }) => {
          if (row.original.isDraft) {
            return (
              <div style={{ minWidth: 140, maxWidth: 220 }}>
                <CompactAddFiles
                  multiple
                  readOnly={isSavingDraft}
                  files={draft.files || []}
                  onFilesChange={isSavingDraft
                    ? () => {}
                    : (files) => updateDraftField(pedidoCompraId, 'files', files)}
                />
              </div>
            )
          }

          const anexoHref = buildOikosFileUrl(row.original.compraCotacao_anexo_caminho)
          if (!anexoHref) return '-'

          return (
            <IconButton
              size="small"
              title="Abrir anexo"
              onClick={() => window.open(anexoHref, '_blank', 'noopener,noreferrer')}
            >
              <AttachFile style={{ fontSize: 18 }} />
            </IconButton>
          )
        },
      })
    }

    columns.push(
      {
        id: 'acoes',
        header: 'Ações',
        enableColumnActions: false,
        enableSorting: false,
        Cell: ({ row: compraCotacaoRow }) => {
          if (compraCotacaoRow.original.isDraft) {
            return (
              <Button
                size="sm"
                color="primary"
                disabled={isSavingDraft}
                onClick={() => handleSaveDraftProposta(pedidoCompra)}
              >
                {isSavingDraft ? 'Salvando...' : 'Salvar proposta'}
              </Button>
            )
          }

          return (
            <div className="d-flex align-items-center">
              {onViewCompraCotacao && (
                <IconButton
                  size="small"
                  title="Visualizar cotação"
                  onClick={() => onViewCompraCotacao(compraCotacaoRow.original, pedidoCompra)}
                >
                  <Visibility fontSize="small" />
                </IconButton>
              )}
              {renderCompraCotacaoActions(compraCotacaoRow.original, pedidoCompra, compraCotacoes)}
            </div>
          )
        },
      },
    )

    return columns
  }

  const renderDetailPanel = ({ row }) => {
    const pedidoCompra = row.original
    const expandId = getRowExpandId(pedidoCompra, showEquipePedidoCompraFields)
    const cacheKey = String(expandId)
    const isLoadingCompraCotacoes = Boolean(isLoadingCompraCotacoesByPedidoCompraId[cacheKey])
    const compraCotacoes = compraCotacoesByPedidoCompraId[cacheKey] || []

    // Pedidos vinculados a orcItem de Equipe (categGr_id = 2) não exibem "Adicionar proposta".
    const isEquipeOrcItem = Number(pedidoCompra?.categGr_id) === EQUIPE_CATEG_GR_ID
      || showEquipePedidoCompraFields
    const abrirCotacaoButton = isEquipeOrcItem
      ? null
      : (
        typeof onAbrirCotacaoPedidoCompra === 'function' ? (
          <Button
            size="sm"
            color="link"
            className="mb-2 px-0"
            onClick={() => onAbrirCotacaoPedidoCompra(pedidoCompra)}
          >
            Adicionar proposta
          </Button>
        ) : null
      )

    if (isLoadingCompraCotacoes) {
      return (
        <div className="p-2" style={expandedDetailPanelStyle}>
          {showEquipePedidoCompraFields ? abrirCotacaoButton : null}
          <div className="d-flex align-items-center">
            <Spinner size="sm" className="mr-2" />
            <span className="text-muted">{!showEquipePedidoCompraFields ? 'Carregando cotacoes...' : 'Carregando candidatos...'}</span>
          </div>
        </div>
      )
    }

    if (showEquipePedidoCompraFields && compraCotacoes.length <= 0) {
      return (
        <div className="p-2" style={expandedDetailPanelStyle}>
          {abrirCotacaoButton}
          <span className="text-muted">
            Nenhum candidato localizado para esta vaga.
          </span>
        </div>
      )
    }

    if (showEquipePedidoCompraFields) {
      const detailColumns = [
        ...compraCotacaoColumns,
        {
          id: 'acoes',
          header: 'Ações',
          enableColumnActions: false,
          enableSorting: false,
          Cell: ({ row: compraCotacaoRow }) => (
            <div className="d-flex align-items-center">
              {renderCompraCotacaoActions(compraCotacaoRow.original, pedidoCompra, compraCotacoes)}
            </div>
          ),
        },
      ]

      return (
        <div className="p-2" style={expandedDetailPanelStyle}>
          {abrirCotacaoButton}
          <h6 className="mb-3">Candidatos</h6>
          <MaterialReactTable
            columns={detailColumns}
            data={compraCotacoes}
            getRowId={(compraCotacao) => String(compraCotacao.candidato_id)}
            localization={MRT_Localization_PT}
            initialState={{
              density: 'compact',
              pagination: { pageIndex: 0, pageSize: 10 },
            }}
            enableColumnActions={false}
            enableColumnFilters={false}
            enableGlobalFilter
            enableDensityToggle={false}
            enablePagination={compraCotacoes.length > 10}
            muiTopToolbarProps={mrtTopToolbarProps}
            muiTableHeadCellColumnActionsButtonProps={{ size: '8px' }}
            muiTablePaperProps={{ sx: { boxShadow: 'none', border: '1px solid #c5dbe5', backgroundColor: '#fff' } }}
            muiTableBodyCellProps={{ sx: { fontSize: '12px' } }}
            muiTableHeadCellProps={mrtHeadCellProps}
          />
        </div>
      )
    }

    const pedidoCompraId = Number(pedidoCompra?.pedidoCompra_id) || 0
    const draft = draftByPedidoCompraId[String(pedidoCompraId)] || createEmptyDraft()
    const tableData = [...compraCotacoes, draft]
    const detailColumns = buildPedidoPropostaDetailColumns(pedidoCompra, compraCotacoes)

    return (
      <div className="p-2" style={expandedDetailPanelStyle}>
        <h6 className="mb-3">Propostas</h6>
        <MaterialReactTable
          columns={detailColumns}
          data={tableData}
          getRowId={(compraCotacao) => (
            compraCotacao.isDraft
              ? DRAFT_ROW_ID
              : String(compraCotacao.compraCotacao_id)
          )}
          localization={MRT_Localization_PT}
          initialState={{
            density: 'compact',
            pagination: { pageIndex: 0, pageSize: 10 },
          }}
          enableColumnActions={false}
          enableColumnFilters={false}
          enableGlobalFilter
          enableDensityToggle={false}
          enablePagination={compraCotacoes.length > 10}
          muiTopToolbarProps={mrtTopToolbarProps}
          muiTableHeadCellColumnActionsButtonProps={{ size: '8px' }}
          muiTablePaperProps={{ sx: { boxShadow: 'none', border: '1px solid #c5dbe5', backgroundColor: '#fff' } }}
          muiTableBodyCellProps={{ sx: { fontSize: '12px' } }}
          muiTableHeadCellProps={mrtHeadCellProps}
        />
      </div>
    )
  }

  return (
    <>
      {isLoading ? (
        <div className="py-4 d-flex align-items-center justify-content-center">
          <Spinner className="mr-2" />
          <span className="text-muted">{resolvedLoadingLabel}</span>
        </div>
      ) : (
        <MaterialReactTable
          columns={columns}
          data={pedidosCompra}
          getRowId={(row) => getRowListagemKey(row, showEquipePedidoCompraFields)}
          localization={MRT_Localization_PT}
          initialState={{
            density: 'compact',
            pagination: { pageIndex: 0, pageSize: 10 },
          }}
          state={{ expanded: expandedPedidosCompra }}
          onExpandedChange={handleExpandedChange}
          enableRowExpansion
          enableExpandAll={false}
          renderDetailPanel={renderDetailPanel}
          enableColumnActions={false}
          enableColumnFilters={false}
          enableDensityToggle={false}
          enableGlobalFilter
          enablePagination={pedidosCompra.length > 10}
          muiTopToolbarProps={mrtTopToolbarProps}
          muiTableHeadCellColumnActionsButtonProps={{ size: '8px' }}
          muiTablePaperProps={{ sx: { boxShadow: 'none', border: '1px solid #eef0f3', marginTop: '1rem' } }}
          muiTableBodyCellProps={{ sx: { fontSize: '13px', whiteSpace: 'normal', overflowWrap: 'break-word' } }}
          muiTableHeadCellProps={mrtHeadCellProps}
          muiTableBodyRowProps={({ row }) => {
            if (!row.getIsExpanded()) return {}
            return {
              sx: {
                backgroundColor: '#e8f3f7',
                boxShadow: 'inset 4px 0 0 0 #2f7d95',
                '& > td': {
                  backgroundColor: '#e8f3f7',
                  borderTop: '1px solid #b7d4df',
                },
              },
            }
          }}
          muiDetailPanelProps={() => ({
            sx: {
              backgroundColor: '#e8f3f7',
              boxShadow: 'inset 4px 0 0 0 #2f7d95',
              '& > td': {
                backgroundColor: '#e8f3f7',
                borderBottom: '2px solid #2f7d95',
                paddingTop: '0.75rem',
                paddingBottom: '0.75rem',
              },
            },
          })}
          muiTablePaginationProps={{
            sx: { '.MuiTablePagination-displayedRows': { fontSize: '12px' }, fontSize: '12px' },
            labelRowsPerPage: <span style={{ fontSize: '12px' }}>Itens por página</span>,
            rowsPerPageOptions: [10, 20, 50],
          }}
          positionPagination="bottom"
        />
      )}

      <ModalConfirmacao
        openModal={linkOrcItemModal.open}
        title="Vincular item orçamentário"
        text="Esta cotação ainda não possui item orçamentário. Selecione o centro de custo e o item orçamentário para continuar com a contratação."
        confirmButtonText="Salvar"
        cancelButtonText="Cancelar"
        isLoading={isSavingOrcItemLink}
        onClosed={handleCloseLinkOrcItemModal}
        onConfirm={handleSavePedidoCompraOrcItem}
        childComponent={(
          <div>
            <FormGroup>
              <Label>Centro de custo</Label>
              <Select
                classNamePrefix="select2-selection"
                placeholder="Selecione um centro de custo"
                isClearable
                options={selCentroDeCustoLink}
                value={selCentroDeCustoLink.filter((item) => (
                  Number(item.value) === Number(linkOrcItemForm.centroDeCustoRubr_id)
                ))}
                onChange={handleCentroDeCustoLinkChange}
              />
            </FormGroup>
            <FormGroup>
              <Label>Item orçamentário</Label>
              <Select
                classNamePrefix="select2-selection"
                placeholder={isLoadingOrcItemsLink ? 'Carregando...' : 'Selecione um item'}
                isClearable
                isDisabled={!linkOrcItemForm.centroDeCustoRubr_id || isLoadingOrcItemsLink}
                isLoading={isLoadingOrcItemsLink}
                options={selOrcItemsLink}
                value={selOrcItemsLink.filter((item) => (
                  Number(item.value) === Number(linkOrcItemForm.orcItem_id)
                ))}
                onChange={(option) => {
                  const newOrcItemId = option?.value ?? null
                  if (newOrcItemId && !Number(option?.pf_id)) {
                    notifyError('Item orçamentário sem responsável')
                    return
                  }
                  setLinkOrcItemForm((prev) => ({
                    ...prev,
                    orcItem_id: newOrcItemId,
                  }))
                }}
              />
            </FormGroup>
          </div>
        )}
      />

      {contrFornModalAfterLink.open && (
        <ModalFormContrForn
          hideTrigger
          isOpen={contrFornModalAfterLink.open}
          onClose={() => setContrFornModalAfterLink({
            open: false,
            compraCotacao: null,
            pedidoCompra: null,
            treatAsPadrao: false,
          })}
          supplierInfoValidationMode={
            Number(contrFornModalAfterLink.compraCotacao?.compraStatus_id) === COMPRA_STATUS_INFO_ENVIADA
            && isPedidoCompraComContrato(contrFornModalAfterLink.pedidoCompra)
          }
          compraCotacaoData={{
            ...contrFornModalAfterLink.compraCotacao,
            orcItem_id: contrFornModalAfterLink.pedidoCompra?.orcItem_id
              || contrFornModalAfterLink.compraCotacao?.orcItem_id,
          }}
          pedidoCompraData={{
            ...contrFornModalAfterLink.pedidoCompra,
            pf_emailProf: contrFornModalAfterLink.pedidoCompra?.pf_emailProf
              || contrFornModalAfterLink.compraCotacao?.pf_emailProf,
            vaga_id: contrFornModalAfterLink.pedidoCompra?.vaga_id || null,
            vaga_documentosObrigatorios: contrFornModalAfterLink.pedidoCompra?.vaga_documentosObrigatorios
              || contrFornModalAfterLink.pedidoCompra?.vagaDocumentosObrigatorios
              || null,
            vaga_beneficios: contrFornModalAfterLink.pedidoCompra?.vaga_beneficios
              || contrFornModalAfterLink.pedidoCompra?.vagaBeneficios
              || null,
          }}
          contrFornData={
            Number(contrFornModalAfterLink.compraCotacao?.contrForn_id)
              ? { contrForn_id: Number(contrFornModalAfterLink.compraCotacao.contrForn_id) }
              : undefined
          }
          loadExistingContrFornOnOpen={Boolean(
            Number(contrFornModalAfterLink.compraCotacao?.contrForn_id),
          )}
          showEquipePedidoCompraFields={showEquipePedidoCompraFields}
          centroDeCustoDisabled
          orcItemDisabled
          {...(contrFornModalAfterLink.treatAsPadrao
            || isPedidoCompraComContrato(contrFornModalAfterLink.pedidoCompra)
            ? compraCotacaoContrFornHidePropsComContratado
            : compraCotacaoContrFornHideProps)}
          onSuccess={async () => {
            await handleContrFornSuccess(contrFornModalAfterLink.pedidoCompra)
            setContrFornModalAfterLink({
              open: false,
              compraCotacao: null,
              pedidoCompra: null,
              treatAsPadrao: false,
            })
          }}
        />
      )}
    </>
  )
}

export default PedidosCompraListTable
